import { derived, writable, type Readable } from "svelte/store";
import { SideMenuOptions } from '$lib/utils/constants';

type FloatingSideMenuState = keyof typeof SideMenuOptions;

function createFloatingSidemenuStore() {

    const defaultState: FloatingSideMenuState = SideMenuOptions.NONE;

    const { subscribe, set, update } = writable<FloatingSideMenuState>(defaultState);
    return {
        update,
        set,
        subscribe,
        reset: () => 
            update((store) => {
                store = SideMenuOptions.NONE;
                return store;
            })
    };
}

const floatingSidemenuState = createFloatingSidemenuStore();

/**
 * If sidemenuState is set to SideMenuOptions.NONE the sidemenu will be closed.
 *
 * SHOW_LAYERPICKINGINFO is excluded as well: feature info from the external WMS map layers
 * renders in its own modal (MapFeatureInfoModal.svelte), so the panel must stay shut for it.
 */
const floatingSidemenuOpen: Readable<boolean> = derived(floatingSidemenuState, ($floatingSidemenuState) => {
    return $floatingSidemenuState !== SideMenuOptions.NONE
        && $floatingSidemenuState !== SideMenuOptions.SHOW_LAYERPICKINGINFO;
});

export {
    floatingSidemenuState,
    floatingSidemenuOpen
}